import React from "react";
import "./LayoutContainer.css";

const LayoutContainer = ({ children }) => (
  <div className="sdlcreative-layout-container">
    {children}
  </div>
);

export default LayoutContainer;
